import FadeTransition from '../transitions/FadeTransition'

export default class TransitionFactory {
  getTransition(previousState, state) {
    switch (state.transitionName) {
      // case 'other':
      //     return new Other();
      default:
        return new FadeTransition()
    }
  }
}
